/* Christmas on the Square — landing page behavior. v1.5.16
   Vanilla JS only; everything respects prefers-reduced-motion. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isNarrow = window.matchMedia('(max-width: 767px)').matches;

  /* ---------- snowfall ---------- */

  function startSnow(canvas) {
    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var flakes = [];
    var running = false;
    var count = isNarrow ? 66 : 137;

    function size() {
      var rect = canvas.parentElement.getBoundingClientRect();
      canvas.width = rect.width * dpr;
      canvas.height = rect.height * dpr;
    }

    function reset(f, fromTop) {
      f.x = Math.random() * canvas.width;
      f.y = fromTop ? -10 * dpr : Math.random() * canvas.height;
      f.r = (0.8 + Math.random() * 1.9) * dpr;
      f.vy = (0.25 + Math.random() * 0.5) * dpr;
      f.vx = (Math.random() - 0.5) * 0.3 * dpr;
      f.o = 0.35 + Math.random() * 0.5;
      f.phase = Math.random() * Math.PI * 2;
    }

    size();

    // Re-size the bitmap when the element itself changes size (image loads,
    // layout shifts) — otherwise flakes stretch into streaks.
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(size).observe(canvas.parentElement);
    }

    for (var i = 0; i < count; i++) {
      var f = {};
      reset(f, false);
      flakes.push(f);
    }

    function tick(t) {
      if (!running) return;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = '#faf3e3';
      for (var i = 0; i < flakes.length; i++) {
        var f = flakes[i];
        f.y += f.vy;
        f.x += f.vx + Math.sin(t / 2400 + f.phase) * 0.18 * dpr;
        if (f.y > canvas.height + 10 * dpr) reset(f, true);
        ctx.globalAlpha = f.o;
        ctx.beginPath();
        ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
        ctx.fill();
      }
      ctx.globalAlpha = 1;
      requestAnimationFrame(tick);
    }

    window.addEventListener('resize', size);

    // Only animate while on screen.
    new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      if (visible && !running) {
        running = true;
        requestAnimationFrame(tick);
      } else if (!visible) {
        running = false;
      }
    }).observe(canvas);
  }

  if (!reduceMotion) {
    document.querySelectorAll('.advent-snow').forEach(startSnow);
  }

  /* ---------- the walk: scroll-driven dusk ---------- */

  document.querySelectorAll('.advent-walk').forEach(function (walk) {
    var thresholdEls = walk.querySelectorAll('[data-at]');
    var heroOverlay = walk.querySelector('.advent-walk__hero');

    if (reduceMotion) {
      walk.classList.add('static');
      thresholdEls.forEach(function (el) {
        el.classList.add(el.classList.contains('advent-walk__glow') ? 'lit' : 'in');
      });
      walk.style.setProperty('--p', '1');
      // Beats/drawers are position:static in this mode; nothing else to do.
      return;
    }

    var stage = walk.querySelector('.advent-walk__stage');
    var cue = walk.querySelector('.advent-scrollcue');
    var art = walk.querySelector('.advent-walk__art');
    var glows = walk.querySelector('.advent-walk__glows');

    // Pin the stage height in pixels once. Firefox on iPhone resizes viewport
    // units as its toolbar collapses; a pixel height can't breathe. Re-measure
    // only when the width changes (a real rotation), never on height-only
    // (toolbar) resizes.
    var pinProbe = document.createElement('div');
    pinProbe.style.cssText = 'position:fixed;top:0;left:-1px;width:1px;height:100lvh;visibility:hidden;pointer-events:none;';
    document.body.appendChild(pinProbe);
    var pinnedW = window.innerWidth;
    function pinStage() {
      var h = pinProbe.offsetHeight || window.innerHeight;
      stage.style.height = h + 'px';
      // Anchor the control pill just above whatever is visible at load —
      // computed from real geometry, not per-browser guesses.
      var cueBottom = Math.max(32, h - window.innerHeight + 24);
      stage.style.setProperty('--cue-bottom', cueBottom + 'px');
    }
    pinStage();
    window.addEventListener('resize', function () {
      if (window.innerWidth !== pinnedW) {
        pinnedW = window.innerWidth;
        pinStage();
      }
    });

    // Camera waypoints: [progress, scale, focusX%, focusY%].
    // Drawer 8 → clock tower · drawer 16 → gazebo · sealed 25 → pull back.
    // One camera keyframe per station — nothing in between. Each glide then
    // sweeps exactly one segment, so the whole move shares the glide's single
    // ease-out/ease-in bell: no mid-glide holds, no lurches, no drifting tail.
    // Keyframe p values are the station landing points (beat at + 0.03).
    var CAM = [
      [0, 1.06, 50, 55],
      [0.11, 1.1, 50, 55],
      [0.24, 1.55, 25, 12],
      [0.37, 1.12, 50, 55],
      [0.51, 2.1, 55, 57],
      [0.64, 1.5, 80, 45],
      [0.77, 1.6, 48, 72],
      [0.9, 1.02, 50, 52],
      [0.98, 1.02, 50, 52],
      [1, 1.08, 50, 54]
    ];

    // Resolve each waypoint to its final screen transform up front (focus
    // centered, clamped so the cover-fit art never shows gaps), and
    // interpolate those transforms directly. Clamping mid-move used to bend
    // the trajectory — the camera would pan, hit the clamp, and finish on a
    // different heading: two moves instead of one curve. Between two valid
    // transforms the straight line is always gap-free.
    var CAMT = CAM.map(function (w) {
      var s = w[1];
      var max = 50 * (s - 1);
      var tx = Math.max(-max, Math.min(max, -(w[2] - 50) * s));
      var ty = Math.max(-max, Math.min(max, -(w[3] - 50) * s));
      return [w[0], s, tx, ty];
    });

    function camera(p) {
      var a = CAMT[0];
      var b = CAMT[CAMT.length - 1];
      for (var i = 0; i < CAMT.length - 1; i++) {
        if (p >= CAMT[i][0] && p <= CAMT[i + 1][0]) {
          a = CAMT[i];
          b = CAMT[i + 1];
          break;
        }
      }
      var u = b[0] === a[0] ? 0 : (p - a[0]) / (b[0] - a[0]);
      // Linear between waypoints — the glide easing and the camera damping
      // provide all the smoothing.
      var s = a[1] + (b[1] - a[1]) * u;
      var tx = a[2] + (b[2] - a[2]) * u;
      var ty = a[3] + (b[3] - a[3]) * u;
      return 'translate(' + tx.toFixed(2) + '%, ' + ty.toFixed(2) + '%) scale(' + s.toFixed(3) + ')';
    }

    // The scene's own clock: p (0–1) is story progress, advanced by the
    // player controls — never by the scroll position.
    var p = 0;
    var glideRaf = null;

    function render() {
      stage.style.setProperty('--p', p.toFixed(4));

      var cam = camera(p);
      if (art) art.style.transform = cam;
      if (glows) glows.style.transform = cam;

      // Bright at the hero, night falls mid-walk, eases as lights come on —
      // then fully lifts for the finale: the square actually lights up.
      var nightO;
      if (p < 0.3) nightO = 0.12 + p * 1.5; // dusk settles before the lights cascade
      else if (p < 0.45) nightO = 0.57;
      else if (p < 0.93) nightO = Math.max(0.26, 0.57 - (p - 0.45) * 0.5);
      else nightO = Math.max(0, 0.325 * (1 - (p - 0.93) / 0.07)); // fully lit from the calendar beat on
      stage.style.setProperty('--night-o', nightO.toFixed(3));

      if (heroOverlay) heroOverlay.classList.toggle('out', p > 0.1);
      if (cue) {
        cue.classList.toggle('mini', p > 0.05); // label only belongs on the untouched hero
        cue.classList.toggle('out', p > 0.955); // controls stay through the calendar beat
      }
      stage.classList.toggle('advent-walking', p > 0.1);
      stage.classList.toggle('advent-finale-lit', p > 0.93);

      thresholdEls.forEach(function (el) {
        var at = parseFloat(el.getAttribute('data-at'));
        var cls = el.classList.contains('advent-walk__glow') || el.classList.contains('advent-rail__dot') ? 'lit' : 'in';
        // Beats fade back out once the walk moves on.
        var until = parseFloat(el.getAttribute('data-until') || '2');
        if (p >= at && p < until) {
          el.classList.add(cls);
        } else {
          el.classList.remove(cls);
          if (el.classList.contains('open')) {
            el.classList.remove('open');
            el.setAttribute('aria-expanded', 'false');
          }
        }
      });

      document.dispatchEvent(new CustomEvent('advent:progress', { detail: p }));
    }

    function cancelGlide() {
      if (glideRaf) {
        window.cancelAnimationFrame(glideRaf);
        glideRaf = null;
      }
    }

    function glideTo(target, done) {
      target = Math.min(1, Math.max(0, target));
      cancelGlide();
      var from = p;
      var dist = Math.abs(target - from);
      if (dist < 0.0005) {
        p = target;
        render();
        if (done) done();
        return;
      }
      var dur = 1400 + 5200 * dist; // longer moves take longer — cinematic pace
      var t0 = null;
      function step(ts) {
        if (t0 === null) t0 = ts;
        var u = Math.min(1, (ts - t0) / dur);
        u = u * u * u * (u * (u * 6 - 15) + 10); // smootherstep — velvet in/out
        p = from + (target - from) * u;
        render();
        if (u < 1) {
          glideRaf = window.requestAnimationFrame(step);
        } else {
          glideRaf = null;
          if (done) done();
        }
      }
      glideRaf = window.requestAnimationFrame(step);
    }

    // The player controls (below) drive the scene through this handle.
    walk.adventScene = {
      getP: function () { return p; },
      glideTo: glideTo,
      cancelGlide: cancelGlide,
      reset: function () {
        cancelGlide();
        p = 0;
        render();
      }
    };

    render();
  });

  /* ---------- music: Dance of the Sugar Plum Fairy (muted by default) ---------- */

  var musicBtn = document.querySelector('.advent-music');

  var music = (function () {
    var audio = null;
    var fadeTimer = null;
    var on = false;
    var canFade = true;
    var VOLUME = 0.35;

    function ensure() {
      if (audio || !musicBtn) return;
      var src = musicBtn.getAttribute('data-src');
      if (!src) return;
      audio = new window.Audio(src);
      audio.loop = true;
      audio.preload = 'none';
      // iOS ignores programmatic volume — detect it, or mute would wait on a
      // fade that can never finish.
      audio.volume = 0;
      canFade = audio.volume === 0;
      musicBtn.adventAudio = audio; // exposed for the QA probes
    }

    function fadeTo(target, done) {
      if (fadeTimer) window.clearInterval(fadeTimer);
      var ticks = 0;
      fadeTimer = window.setInterval(function () {
        ticks++;
        var v = audio.volume + (target > audio.volume ? 0.05 : -0.05);
        v = Math.max(0, Math.min(VOLUME, v));
        audio.volume = v;
        if (Math.abs(audio.volume - target) < 0.01 || ticks > 20) {
          audio.volume = target;
          window.clearInterval(fadeTimer);
          if (done) done();
        }
      }, 60);
    }

    return {
      start: function () {
        if (on) return;
        ensure();
        if (!audio) return;
        on = true;
        audio.play().then(function () {
          if (canFade) fadeTo(VOLUME);
        }).catch(function () {
          on = false; // autoplay blocked — stay muted until a gesture
          if (musicBtn) {
            musicBtn.classList.remove('playing');
            musicBtn.setAttribute('aria-pressed', 'false');
          }
        });
      },
      stop: function () {
        on = false;
        if (!audio) return;
        if (canFade) {
          fadeTo(0, function () {
            audio.pause();
          });
        } else {
          audio.pause(); // no volume control (iOS) — cut immediately
        }
      },
      isOn: function () {
        return on;
      }
    };
  })();
  // Audio is on by default. Browsers require a gesture before sound, so the
  // first tap, click, or keypress anywhere starts the music — unless the
  // visitor has muted it (speaker button or pausing the show).
  var musicAutoOn = true;

  if (musicBtn) {
    var syncMusicBtn = function () {
      musicBtn.classList.toggle('playing', music.isOn());
      musicBtn.setAttribute('aria-pressed', music.isOn() ? 'true' : 'false');
      musicBtn.setAttribute('aria-label', music.isOn() ? 'Pause music' : 'Play music');
    };
    musicBtn.addEventListener('click', function () {
      if (music.isOn()) {
        music.stop();
        musicAutoOn = false;
      } else {
        music.start();
        musicAutoOn = true;
      }
      syncMusicBtn();
    });
    ['pointerdown', 'keydown'].forEach(function (ev) {
      window.addEventListener(ev, function (e) {
        // A tap on the speaker itself must not count — its pointerdown would
        // auto-start the music and its click would then toggle it right off.
        if (e && e.target && musicBtn.contains(e.target)) return;
        if (musicAutoOn && !music.isOn()) {
          music.start();
          syncMusicBtn();
        }
      }, { passive: true });
    });
  }

  /* ---------- player: play/pause drives the scene; scrolling just scrolls ---------- */

  document.querySelectorAll('.advent-walk').forEach(function (walk) {
    var playBtn = walk.querySelector('.advent-scrollcue__play');
    var scene = walk.adventScene;
    if (!playBtn) return;
    if (reduceMotion || !scene) {
      playBtn.style.display = 'none';
      return;
    }

    var stops = [];
    walk.querySelectorAll('.advent-walk__beat, .advent-drawer, .advent-walk__finale').forEach(function (el) {
      var at = parseFloat(el.getAttribute('data-at'));
      if (!isNaN(at)) stops.push(at);
    });
    stops.sort(function (a, b) { return a - b; });
    if (!stops.length) {
      playBtn.style.display = 'none';
      return;
    }

    var DWELL = 2000;
    var playing = false;
    var timer = null;

    function stop() {
      playing = false;
      if (timer) window.clearTimeout(timer);
      scene.cancelGlide();
      playBtn.classList.remove('playing');
      playBtn.setAttribute('aria-pressed', 'false');
    }

    function advance() {
      if (!playing) return;
      var pNow = scene.getP();
      var next = null;
      for (var i = 0; i < stops.length; i++) {
        if (stops[i] > pNow - 0.025) {
          next = stops[i];
          break;
        }
      }
      if (next === null) {
        stop(); // the show ends on the finale
        return;
      }
      scene.glideTo(Math.min(next + 0.03, 1), function () {
        if (!playing) return;
        timer = window.setTimeout(advance, DWELL);
      });
    }

    playBtn.addEventListener('click', function (e) {
      if (playing) {
        stop();
        // An explicit pause quiets the music too.
        if (e.isTrusted && music.isOn()) {
          music.stop();
          musicAutoOn = false;
          if (musicBtn && typeof syncMusicBtn === 'function') syncMusicBtn();
        }
        return;
      }
      // Music comes along by default; an explicit play also clears a mute.
      if (e.isTrusted) musicAutoOn = true;
      if (musicAutoOn && !music.isOn()) {
        music.start();
        if (musicBtn && typeof syncMusicBtn === 'function') syncMusicBtn();
      }
      playing = true;
      playBtn.classList.add('playing');
      playBtn.setAttribute('aria-pressed', 'true');
      if (scene.getP() >= 0.97) scene.reset(); // pressing play at the end starts over
      advance();
    });

    // The show also starts on its own, 4s after landing, and keeps playing
    // even if the visitor scrolls on — it's there whenever they glance back.
    window.setTimeout(function () {
      if (!playing && scene.getP() < 0.02) playBtn.click();
    }, 4000);

    // Replay (on the finale): back to the opening frame, then play again.
    var replay = walk.querySelector('.advent-replay');
    if (replay) {
      replay.addEventListener('click', function (e) {
        stop();
        scene.reset();
        // An explicit restart brings the music, like an explicit play.
        if (e.isTrusted) musicAutoOn = true;
        if (musicAutoOn && !music.isOn()) {
          music.start();
          if (musicBtn && typeof syncMusicBtn === 'function') syncMusicBtn();
        }
        window.setTimeout(function () {
          if (!playing) playBtn.click();
        }, 900);
      });
    }

    // Back / forward arrows step the show station to station.
    walk.querySelectorAll('.advent-scrollcue__nav').forEach(function (btn) {
      var forwardNav = btn.classList.contains('advent-scrollcue__next');
      btn.addEventListener('click', function () {
        stop(); // the arrows take manual control
        var pNow = scene.getP();
        var target = null;
        var i;
        if (forwardNav) {
          for (i = 0; i < stops.length; i++) {
            if (stops[i] + 0.03 > pNow + 0.01) {
              target = Math.min(stops[i] + 0.03, 1);
              break;
            }
          }
        } else {
          for (i = stops.length - 1; i >= 0; i--) {
            if (stops[i] + 0.03 < pNow - 0.01) {
              target = Math.min(stops[i] + 0.03, 1);
              break;
            }
          }
          if (target === null) target = 0; // back past the first stop → the hero
        }
        if (target !== null) scene.glideTo(target);
      });
    });
  });

  /* ---------- sticky reserve bar ---------- */

  var bar = document.querySelector('.advent-bar');
  var reserve = document.getElementById('reserve');
  var heroOverlay = document.querySelector('.advent-walk__hero');

  if (bar) {
    var heroGone = false;
    var scenePast = false;
    var reserveVisible = false;

    var updateBar = function () {
      var shown = (heroGone || scenePast) && !reserveVisible;
      bar.classList.toggle('show', shown);
      document.body.classList.toggle('advent-bar-on', shown);
    };

    // The hero copy can leave two ways now: scrolled past (normal page flow)
    // or faded by the playing scene. Either one deserves a Reserve CTA.
    if (heroOverlay) {
      new IntersectionObserver(function (entries) {
        heroGone = !entries[0].isIntersecting;
        updateBar();
      }, { threshold: 0.05 }).observe(heroOverlay);
    }
    document.addEventListener('advent:progress', function (e) {
      scenePast = e.detail > 0.1;
      updateBar();
    });

    if (reserve) {
      new IntersectionObserver(function (entries) {
        reserveVisible = entries[0].isIntersecting;
        updateBar();
      }, { threshold: 0.15 }).observe(reserve);
    }
  }

  /* ---------- drawer cards open on click ---------- */

  document.querySelectorAll('.advent-drawer').forEach(function (drawer) {
    var more = drawer.querySelector('.advent-drawer__more');
    if (!more) return;
    drawer.setAttribute('tabindex', '0');
    drawer.setAttribute('role', 'button');
    drawer.setAttribute('aria-expanded', 'false');

    function toggle() {
      var open = drawer.classList.toggle('open');
      drawer.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('a')) return;
      toggle();
    });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle();
      }
    });
  });

  /* ---------- daily unveil: doors open by date (?day=N in preview) ---------- */

  document.querySelectorAll('.advent-unveil').forEach(function (unveil) {
    var preview = unveil.getAttribute('data-preview') === 'true';
    var today = parseInt(unveil.getAttribute('data-today'), 10) || 0;

    if (preview) {
      var m = window.location.search.match(/[?&]day=(\d+)/);
      if (m) {
        today = Math.min(25, Math.max(0, parseInt(m[1], 10)));
        var note = unveil.querySelector('.advent-unveil__previewnote');
        if (note) {
          note.hidden = false;
          var n = note.querySelector('span');
          if (n) n.textContent = today;
        }
        var waiting = unveil.querySelector('.advent-unveil__waiting');
        if (waiting) waiting.hidden = today > 0;
      }
    }

    var doors = unveil.querySelectorAll('.advent-door');
    var details = unveil.querySelectorAll('.advent-unveil__detail');
    var stage = unveil.querySelector('.advent-unveil__stage');
    var bigdoor = unveil.querySelector('.advent-bigdoor');
    var doorNum = unveil.querySelector('.advent-bigdoor__num');
    var doorInside = unveil.querySelector('.advent-bigdoor__inside');
    var openme = unveil.querySelector('.advent-unveil__openme');
    var copy = unveil.querySelector('.advent-unveil__stagecopy');
    var current = 0;
    var revealed = {};

    function detailFor(day) {
      var found = null;
      details.forEach(function (d) {
        if (parseInt(d.getAttribute('data-day'), 10) === day) found = d;
      });
      return found;
    }

    function syncGrid() {
      doors.forEach(function (door) {
        var day = parseInt(door.getAttribute('data-day'), 10);
        var has = door.hasAttribute('data-has-content');
        door.classList.toggle('is-open', has && (day < today || revealed[day] === true));
        door.classList.toggle('is-today', has && day === today && today >= 1);
        door.classList.toggle('is-selected', day === current);
      });
    }

    function openDoor() {
      if (!current || !bigdoor) return;
      revealed[current] = true;
      bigdoor.classList.remove('is-teasing');
      bigdoor.classList.add('is-open');
      bigdoor.setAttribute('aria-expanded', 'true');
      if (openme) openme.hidden = true;
      if (stage) stage.classList.add('is-revealed');
      if (copy) {
        // Two frames so the copy re-enters layout first, then its fade runs.
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            copy.classList.add('show');
          });
        });
      }
      syncGrid();
    }

    function load(day) {
      var d = detailFor(day);
      if (!d || !bigdoor) return;
      current = day;
      if (doorNum) doorNum.textContent = day;
      var media = d.querySelector('.advent-unveil__detail-media');
      var text = d.querySelector('.advent-unveil__detail-copy');
      if (doorInside && media) doorInside.innerHTML = media.innerHTML;
      if (copy && text) copy.innerHTML = text.innerHTML;

      var ceremony = day === today && revealed[day] !== true;
      bigdoor.classList.remove('is-open');
      if (copy) copy.classList.remove('show');
      if (stage && ceremony) stage.classList.remove('is-revealed');
      bigdoor.classList.toggle('is-teasing', ceremony);
      bigdoor.setAttribute('aria-expanded', 'false');
      bigdoor.setAttribute(
        'aria-label',
        ceremony ? 'Open the December ' + day + ' drawer' : 'December ' + day + ' drawer'
      );
      if (openme) openme.hidden = !ceremony;
      if (!ceremony) window.setTimeout(openDoor, 220); // already unveiled — swing right open
      syncGrid();
    }

    if (bigdoor) {
      bigdoor.addEventListener('click', function () {
        if (!current) {
          bigdoor.classList.remove('is-shaking');
          void bigdoor.offsetWidth;
          bigdoor.classList.add('is-shaking');
          return;
        }
        if (!bigdoor.classList.contains('is-open')) openDoor();
      });
    }

    doors.forEach(function (door) {
      var day = parseInt(door.getAttribute('data-day'), 10);
      door.addEventListener('click', function () {
        if (!(door.hasAttribute('data-has-content') && day <= today)) {
          door.classList.remove('is-shaking');
          void door.offsetWidth;
          door.classList.add('is-shaking');
          return;
        }
        load(day);
        if (stage) stage.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      });
    });

    syncGrid();
    if (today >= 1) load(Math.min(today, 25));
  });

  /* ---------- scroll diagnostics (?debug=scroll) ---------- */

  if (/[?&]debug=scroll/.test(window.location.search)) {
    var hud = document.createElement('div');
    hud.style.cssText =
      'position:fixed;left:8px;top:8px;z-index:9999;background:rgba(0,0,0,0.82);color:#7CFC00;' +
      'font:11px/1.6 monospace;padding:6px 9px;border-radius:6px;pointer-events:none;white-space:pre;';
    document.body.appendChild(hud);
    var dbgLastIH = window.innerHeight;
    var dbgLastY = window.scrollY;
    var dbgEvents = [];
    (function dbgTick() {
      var ih = window.innerHeight;
      var vv = window.visualViewport ? Math.round(window.visualViewport.height) : 0;
      var y = Math.round(window.scrollY);
      if (ih !== dbgLastIH) {
        dbgEvents.unshift('ih ' + dbgLastIH + '→' + ih + ' @y=' + y + ' dy=' + (y - dbgLastY));
        dbgEvents = dbgEvents.slice(0, 4);
        dbgLastIH = ih;
      }
      dbgLastY = y;
      var stg = document.querySelector('.advent-walk__stage');
      hud.textContent =
        'ih ' + ih + '  vv ' + vv + '\n' +
        'stage ' + (stg ? stg.offsetHeight : 0) + '  y ' + y + '\n' +
        'p ' + (stg ? stg.style.getPropertyValue('--p') : '-') +
        (dbgEvents.length ? '\n' + dbgEvents.join('\n') : '');
      requestAnimationFrame(dbgTick);
    })();
  }

  /* ---------- lightbox: click any content image for a larger look ---------- */

  (function () {
    var imgs = [];
    document.querySelectorAll('.advent-section img').forEach(function (img) {
      if (img.closest('button, a')) return; // buttons/links keep their own click
      img.classList.add('advent-zoomable');
      imgs.push(img);
    });
    if (!imgs.length) return;

    var box = document.createElement('div');
    box.className = 'advent-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Enlarged image');
    var big = document.createElement('img');
    big.alt = '';
    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'advent-lightbox__close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    box.appendChild(big);
    box.appendChild(closeBtn);
    document.body.appendChild(box);

    // Ask the CDN for a bigger rendition of whatever the page was showing.
    function upscale(src) {
      return src
        .replace(/_(\d{2,4})x(\d{0,4})?\./, '_2048x.')
        .replace(/([?&])width=\d+/, '$1width=2048');
    }

    var lastFocus = null;
    function open(img) {
      lastFocus = img;
      big.src = upscale(img.currentSrc || img.src);
      big.alt = img.alt || '';
      box.classList.add('open');
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    }
    function shut() {
      box.classList.remove('open');
      big.removeAttribute('src');
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    imgs.forEach(function (img) {
      img.setAttribute('tabindex', '0');
      img.setAttribute('role', 'button');
      img.addEventListener('click', function () { open(img); });
      img.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          open(img);
        }
      });
    });
    box.addEventListener('click', shut); // anywhere in the overlay closes
    window.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && box.classList.contains('open')) shut();
    });
  })();

  /* ---------- smooth anchor scrolling ---------- */

  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.getElementById(a.getAttribute('href').slice(1));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth' });
    });
  });
})();
